import { TikTokSpecialCampaignDetail } from '@anytag/graphql';
import { TableV2 } from '@anytag/shared-atoms';
import { useTableMaxHeight } from '@anytag/shared-hooks';
import { ActionBar } from './ActionBar';
import {
  TikTokCampaignPostsListTableProps,
  useTikTokCampaignPostsListTable,
  useUpdateTikTokPostsStatus
} from './hooks';

export interface TikTokCampaignPostsListProps extends TikTokCampaignPostsListTableProps {
  loading?: boolean;
  tiktokSpecialCampaign: TikTokSpecialCampaignDetail;
}

export const TikTokCampaignPostsList = ({ posts, loading, tiktokSpecialCampaign }: TikTokCampaignPostsListProps) => {
  const { offsetRef, defaultTableMaxHeight } = useTableMaxHeight();
  const { UpdateTikTokSpecialPostStatusModal } = useUpdateTikTokPostsStatus(tiktokSpecialCampaign.id);
  const { columns, postsActions } = useTikTokCampaignPostsListTable({ posts });

  return (
    <div css={{ position: 'relative' }}>
      <TableV2
        ref={offsetRef}
        loading={loading}
        noTopBorderRadius
        maxHeight={defaultTableMaxHeight}
        rowHeight="61px"
        data={posts}
        columns={columns}
        stickyHeader
      />
      <ActionBar {...postsActions} status={tiktokSpecialCampaign.status} campaignId={tiktokSpecialCampaign.id} />

      <UpdateTikTokSpecialPostStatusModal onSuccess={() => postsActions.setSelectedItemIds([])} />
    </div>
  );
};
